import { SURGERY_PROCEDURE_MAP } from "app/store/dashboard/surgery_types_procedures/constants/procedures";

const resetFilters = (state) => {
  state.procedureFilters = {};
};

export const surgeryProcedureAction = {
  selectProcedure: (state, action) => {
    const procedureId = action.payload;

    if (
      procedureId === state.procedureId ||
      !SURGERY_PROCEDURE_MAP[procedureId]
    ) {
      return;
    }

    state.procedureId = procedureId;
    resetFilters(state);
  },

  resetProcedureFilters: (state) => {
    resetFilters(state);
  },

  setProcedureCondition: (state, action) => {
    const { field, value } = action.payload;

    state.procedureFilters[field] = value;
  },
};
